import { TypographyV3 } from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';
import type { MessageKey } from 'types/LocaleMessageKey';

import Image from '../Image';

export interface RingModelsModalModelProps {
  readonly description: MessageKey;
  readonly imageSrc: string;
  readonly isNew?: boolean;
  readonly title: MessageKey;
}

const RingModelsModalModel = ({
  description,
  imageSrc,
  isNew,
  title,
}: RingModelsModalModelProps): JSX.Element => {
  const t = useTranslations();

  return (
    <div
      className="flex flex-col items-center"
      data-cy="ring-models-modal-model"
    >
      <Image
        height={250}
        localizedAlt={title}
        src={imageSrc}
        width={250}
        className="md:w-44 lg:w-[250px]"
      />
      <TypographyV3 variant="h5">
        {t(title)}
        {Boolean(isNew) && (
          <sup className="mb-1 ml-2 font-serif font-bold italic text-blue-200">
            {t('new')}
          </sup>
        )}
      </TypographyV3>
      <TypographyV3>{t(description)}</TypographyV3>
    </div>
  );
};

export default RingModelsModalModel;
